import React from "react";
import ReactQuill from "react-quill";
import "../../Styles/Form/FormCreate.css";
import { useDispatch } from "react-redux";
import { updateItemQuestion } from "../../Redux/Reducer/FormSlices";

const NameQuestion = ({
  id,
  question,
  module,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  containerIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  return (
    <>
      <div className="singleQuestion_name_Container">
        {questionIndex + 1}.
        <ReactQuill
          modules={module}
          theme="snow"
          className={`custom ${openQuestion === question.id ? "focus" : ""}`}
          onFocus={() => setOpenQuestion(question.id)}
          onBlur={() => setOpenQuestion(null)}
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="nameAns_container">
        <div className="Name">{question.firstName}</div>
        <div className="Name">{question.lastName}</div>
      </div>
    </>
  );
};

export default NameQuestion;
